import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import news from './news'
import shop from './shop'
import storage from './storage'
import loginModal from './loginModal'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    news,
    shop,
    storage,
    loginModal,
  },
  // Was `process.env.DEV`, a name Vue CLI never defines — it only inlines VUE_APP_*,
  // NODE_ENV and BASE_URL — so this has always evaluated to undefined and strict mode
  // has never been on. Pinned to false to keep that behaviour explicit; turning it on
  // for development is a separate decision, since strict mode throws on any mutation
  // made outside a handler.
  strict: false,
})
